import {
  createPaymentEntrySearchParams,
  getCheckoutUrl,
  type PaymentEntry,
} from '../consts/paymentIntent';
import { PAYMENT_URLS } from '../consts/paymentUrls';

export const getPaymentEntryUrl = (
  entry: PaymentEntry,
  countryCode?: string,
) => {
  if (countryCode !== 'KR') return getCheckoutUrl(entry);

  return getPaymentMethodUrl(entry);
};

const getPaymentMethodUrl = (entry: PaymentEntry) => {
  const params = createPaymentEntrySearchParams(entry);
  const query = params.toString();
  const path = `${PAYMENT_URLS.METHODS}/${entry.kind}`;
  return query ? `${path}?${query}` : path;
};

export const getPaymentLoginUrl = (
  entry: PaymentEntry,
  countryCode?: string,
) => {
  const callbackUrl = getPaymentEntryUrl(entry, countryCode);
  return `/login?callbackUrl=${encodeURIComponent(callbackUrl)}`;
};
